import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
import { getFormComponent } from "../config/flowFormRegister";
import customVform from "@/CommonDP/pages/mainMg/lowcode/component/vFormRender.vue";
import { getFlowImage } from "@/CommonDP/utils";
import { getApprove, deleteApprove, initApprovalFlowKey } from "@/CommonDP/components/processComponents/flowNewConfig/mapStore.js";
import { getFileInfoByFileIdAndVersion } from "@/CommonDP/service/vf-component-service";
import personInfoService from "@/CommonDP/service/admin/personInfo-service.js";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import { getStatusName } from "@/CommonDP/components/processComponents/config";
import { Notify, Dialog } from "vant";
// 将vform实例和流程关联到一起
function bind_VF_Flow() {
  const vFormRef = this.$refs.businessForm.$refs.VFR_View.$refs.vFormRef;
  this.approveInfo.vform = vFormRef;
}
// 流程按钮功能区
export const summaryMixins = {
  provide() {
    return {
      getFlowDetail: () => getApprove(this.uuid)
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      prjInfo: (state) => state.projectMg.prjObj
    }),
    // 流程类型 新增:1; 审批:2; 查看:3; 暂存:4; 重新发起:5;
    flowType() {
      return getApprove(this.uuid).flowType;
    },
    flowInfo() {
      return getApprove(this.uuid)?.getMessage();
    },
    status() {
      return this.flowInfo.status;
    },
    flowInstanceOwnerId() {
      return this.flowInfo.flowInstanceOwnerId;
    },
    flowInstanceId() {
      return this.flowInfo.flowInstanceId;
    },
    // 是否有撤回按钮
    withdrawBoolean() {
      return this.status === 2 && (this.flowType === 2 || this.flowType === 3) && this.flowInstanceOwnerId === this.userInfo.userId;
    },
    // 是否有流程再发起按钮
    flowAgainBoolean() {
      return (this.status === 0 || this.status === 3) &&
        (this.flowType === 2 || this.flowType === 3) &&
        this.flowInstanceOwnerId === this.userInfo.userId;
    },
    // 弹框的流程标题
    flowTitle() {
      return (this.flowType === 1 || this.flowType === 4 || this.flowType === 5)
        ? this.userInfo.name + " 发起" + (this.flowInfo.flowName || "流程")
        : "流程详情";
    },
    prjId() {
      return getApprove(this.uuid).prjId || this.prjInfo.prjId || "";
    },
    detail() {
      return getApprove(this.uuid).detail;
    },
    hasSelctor() {
      return this.detail.enablePrjSelector === 1 && !this.detail.isProject;
    },
    // 流程干预
    hasIntervene() {
      return checkPermission(this.$allPerms.FLOW_INSTANCE_PERMISSION) &&
        (this.flowType === 2 || this.flowType === 3) && this.status === 2;
    },
    nodeList() {
      return getApprove(this.uuid).nodeList;
    },
    // 发起流程的参数
    addParams() {
      const { prjId, detail, basicdata } = getApprove(this.uuid);
      const ccUserIdList = detail?.ccList?.map(e => e.userId) || [];
      const flowNodeDtoList = getApprove(this.uuid).getAddNodeList();
      const draftBusinessId = detail.businessId;
      return { ...detail, draftBusinessId, prjId, ccUserIdList, json: { ...basicdata }, flowNodeDtoList };
    },
    isOut() {
      return window.location.href.indexOf("jsName=BimEx") !== -1;
    },
    isStartByNoAssignee() {
      return getApprove(this.uuid)?.detail?.isStartByNoAssignee || 1;
    }
  },
  // source：来源 H5 为手机端
  methods: {
    changeProject(val) {
      getApprove(this.uuid).setPrjId(val);
    },
    // 提交并发起流程
    async submitProcess(source) {
      // 校验必填表单
      try {
        await this.$refs.addApproval.getBasicData();
      } catch (error) {
        this.$message.warning(error || "请填写完整表单");
        return;
      }
      const nextStep = await this.dealNodeDtolist();
      if (!nextStep) return;
      await flowService.addFlow(this.addParams);
      if (source !== "h5") {
        this.$message.success("请求成功");
      } else {
        Notify({ type: "success", message: "请求成功" });
      }
      this.closeDialog();
    },
    // 暂存
    async temporaryStorage(source) {
      await this.$refs.addApproval.getBasicData(false);
      this.temporaryLoading = true;
      const { data } = await flowService.saveDraft(this.addParams);
      console.log(data, "暂存");
      getApprove(this.uuid).setBusinessId(data);
      if (source !== "h5") {
        this.$message.success("暂存成功");
      } else {
        Notify({ type: "success", message: "暂存成功" });
      }
      this.temporaryLoading = false;
    },
    async withdraw(source) {
      await this.$confirm(`您确定撤回当前流程吗?`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      const params = { flowInstanceId: this.flowInstanceId };
      await flowService.withdraw(params);
      if (source !== "h5") {
        this.$success("流程撤回成功");
      } else {
        Notify({ type: "success", message: "流程撤回成功" });
      }
      this.closeDialog();
    },
    async relaunch() {
      const { currentVersionId, flowInstanceId, flowName, flowKey, enterpriseId } = this.flowInfo;
      const data = { currentVersionId, flowInstanceId, flowKey, flowName, enterpriseId, flowType: 5 };
      const res = await flowService.getBusinessForm(this.flowInstanceId);
      const { flowInfo, fileInfoList, object } = res.data || {};
      initApprovalFlowKey(this.uuid, { ...data, ...flowInfo, flowInstanceId: flowInstanceId, json: object, fileInfoList });
    },
    // 流程再发起
    async flowAgainSure(source) {
      // 校验必填表单
      try {
        await this.$refs.addApproval.getBasicData();
      } catch (error) {
        this.$message.warning(error || "请填写完整表单");
        return;
      }
      const nextStep = await this.dealNodeDtolist(source);
      if (!nextStep) return;
      await flowService.restart(this.addParams);
      if (source !== "h5") {
        this.$message.success("重新发起成功");
      } else {
        Notify({ type: "success", message: "重新发起成功" });
      }
      this.closeDialog();
    },
    // 发起流程 获取流程处理人节点用户:申请人自选
    async dealNodeDtolist(source) {
      let boolean = true;
      if (this.nodeList.length === 0) {
        await this.$refs.addApproval.getNodesEditor();
      }
      // 没用历史节点的流程节点
      const futureNodeList = this.nodeList.filter(e => !e.isHistory);
      const index = futureNodeList.findIndex((e, index) => e.assigneeSelectionStrategy === "2" && e.assigneeList.length === 0 && index > 0 && e.runtimeSelectUsers === 0);
      if (index > -1) {
        if (source !== "h5") {
          this.$message.warning("有节点为申请人自选，请选择节点的审批人");
        } else {
          Notify({ type: "warning", message: "有节点为申请人自选，请选择节点的审批人" });
        }
        return false;
      }
      // 下一个节点为申请人自选
      const nextNode = futureNodeList[1];
      if (nextNode.assigneeList.length === 0 && nextNode.assigneeSelectionStrategy === "2") {
        if (source !== "h5") {
          this.$message.warning("下个节点为申请人自选，请选择下个节点的审批人");
        } else {
          Notify({ type: "warning", message: "下个节点为申请人自选，请选择下个节点的审批人" });
        }
        return false;
      }
      // 判断节点有无审批人
      if (this.isStartByNoAssignee === 0) {
        futureNodeList.forEach((element, index) => {
          if (index > 0 && element.assigneeList.length === 0 && element.runtimeSelectUsers === 0) {
            if (source !== "h5") {
              this.$message.warning("有节点无审批人，请选择节点的审批人");
            } else {
              Notify({ type: "warning", message: "有节点无审批人，请选择节点的审批人" });
            }
            boolean = false;
          }
        });
      }
      return boolean;
    },
    async handleCommand(val) {
      switch (val) {
        case "rejectAdmin":
          this.rejectAdmin("web");
          break;
        case "terminationAdmin":
          this.terminationAdmin("web");
          break;
        case "passNodeAdmin":
          this.passNodeAdmin("web");
          break;
        case "passAdmin":
          this.passAdmin("web");
          break;
        default:
          break;
      }
    },
    // 管理员流程节点驳回
    async rejectAdmin(source) {
      if (source !== "h5") {
        await this.$confirm(`您确定驳回当前流程吗?`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        const params = { flowInstanceId: this.flowInstanceId };
        await flowService.rejectAdmin(params);
        this.$message.success("请求成功");
      } else {
        await Dialog.confirm({ message: "您确定驳回当前流程吗?" });
        const params = { flowInstanceId: this.flowInstanceId };
        await flowService.rejectAdmin(params);
        Notify({ type: "success", message: "请求成功" });
      }
      this.closeDialog();
    },
    // 管理员流程节点终止
    async terminationAdmin(source) {
      if (source !== "h5") {
        await this.$confirm(`您确定终止当前流程吗?`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        const params = { flowInstanceId: this.flowInstanceId };
        await flowService.terminationAdmin(params);
        this.$message.success("请求成功");
      } else {
        await Dialog.confirm({ message: "您确定终止当前流程吗?" });
        const params = { flowInstanceId: this.flowInstanceId };
        await flowService.terminationAdmin(params);
        Notify({ type: "success", message: "请求成功" });
      }
      this.closeDialog();
    },
    // 管理员通过当前流程节点
    async passNodeAdmin(source) {
      if (source !== "h5") {
        await this.$confirm(`您确定通过当前节点吗?`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
      } else {
        await Dialog.confirm({ message: "您确定通过当前节点吗?" });
      }
      const nodeList = getApprove(this.uuid)?.getFlowNodeDtoList() || [];
      const index = nodeList.findIndex(e => e.nodeStatus === "2");
      const flowNodeId = nodeList.find(e => e.nodeStatus === "2").flowNodeId;
      // 下个节点的id 没有默认为0
      const flowNextNodeId = nodeList[index + 1]?.flowNodeDefinitionId || 0;
      // 下个节点是否允许增加审批人
      const allowAddApproverDynamic = nodeList[index + 1]?.allowAddApproverDynamic || 0;
      // 下个节点的审批人
      const nextNodeAssigneeList = nodeList.find(e => e.flowNodeDefinitionId === flowNextNodeId)?.assigneeList;
      let nextNodeAssignee = {};
      // 下个节点允许增加审批人
      if (allowAddApproverDynamic === 1) {
        if (nextNodeAssigneeList && nextNodeAssigneeList.length === 0) {
          this.$message.warning("请先选择下个节点的审批人");
          return;
        }
        const { assigneeList = [], ccList = [] } = nodeList.find(e => e.flowNodeDefinitionId === flowNextNodeId);
        const userDtoList = [...assigneeList.map(e => { return { ...e, type: 0 }; }), ...ccList.map(e => { return { ...e, type: 1 }; })];
        nextNodeAssignee = {
          flowNodeDefinitionId: flowNextNodeId,
          userDtoList: userDtoList
        };
      }
      const { fileInfoList } = getApprove(this.uuid);
      const basicdata = await this.$refs.flowDetail.getBasicData();
      const params = {
        comment: "",
        fileIds: [],
        flowInstanceNodeId: flowNodeId,
        json: { fileInfoList, ...basicdata },
        nextNodeAssignee: allowAddApproverDynamic === 1 ? nextNodeAssignee : {}
      };
      await flowService.passNodeAdmin(params);
      if (source !== "h5") {
        this.$message.success("请求成功");
      } else {
        Notify({ type: "success", message: "请求成功" });
      }
      this.closeDialog();
    },
    // 管理员通过流程
    async passAdmin(source) {
      if (source !== "h5") {
        await this.$confirm(`您确定通过流程吗?`, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        const params = { flowInstanceId: this.flowInstanceId };
        await flowService.passAdmin(params);
        this.$message.success("请求成功");
      } else {
        await Dialog.confirm({ message: "您确定通过流程吗?" });
        const params = { flowInstanceId: this.flowInstanceId };
        await flowService.passAdmin(params);
        Notify({ type: "success", message: "请求成功" });
      }
      this.closeDialog();
    },
    // 审批状态
    statusName(status) {
      return getStatusName(Number(status));
    },

    async handleClose() {
      deleteApprove(this.uuid);
      if (this.isOut) {
        await CefSharp.BindObjectAsync("cefSharpBrower");
        cefSharpBrower.closeWindow();
      } else if (this.fullscreen) {
        window.close();
      } else {
        this.flowDialog = false;
      }
    }
  }
};
// 发起、再发起流程
export const addApprovalMixins = {
  data() {
    return {
      loading: false,
      flowMessage: {},
      basicForm: "",
      showType: "", // user:处理人 ,img:流程图
      showSteps: false,
      comKey: 0,
      approvalPrjId: ""
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    // 流程类型 新增:1; 审批:2; 查看:3; 暂存:4; 重新发起:5;
    flowType() {
      return getApprove(this.uuid).flowType;
    },
    approveInfo() {
      return getApprove(this.uuid);
    },
    flowInfo() {
      return this.approveInfo?.getMessage();
    },
    formType() {
      return this.flowInfo.formType;
    },
    fileList() {
      return this.flowInfo?.attachedFiles?.map((e) => {
        return { ...e, fileId: e.fileId, fileName: e.fileName };
      }) || [];
    },
    flowImage() {
      return getFlowImage(this.flowInfo.flowImage.slice(7));
    },
    // 是否低代码 true ：是
    isLowCode() {
      return this.flowInfo.customerForm === 2;
    },
    prjId() {
      return this.approveInfo.getPrjId() || this.prjInfo.prjId;
    },
    urlFiles() {
      return this.flowInfo.urlFiles || [];
    }
  },
  watch: {
    prjId(newPrjId) {
      if (this.formType === 1) {
        this.changeProject(newPrjId);
      }
    }
  },
  methods: {
    async addInit(isH5) {
      this.loading = true;
      this.comKey++;
      // 低代码vform设计的表单 默认属性
      if (this.isLowCode) {
        this.basicForm = customVform;
      } else {
        // 设置是否提供项目选择器
        this.approveInfo.setPrjId(this.prjId);
        const params = {
          ...this.flowInfo,
          name: this.flowInfo.flowName
          // prjId: this.approvalPrjId
        };
        this.$store.dispatch("setRouterParams", params);
        this.basicForm = getFormComponent(this.flowInfo.flowKey, isH5);
        if (this.flowType === 4 || this.flowType === 5) {
          await this.$nextTick();
          const json = this.approveInfo.getFormData();
          this.$refs.businessForm?.setFormData(json);
        }
        this.loading = false;
      }
    },
    // 低代码vform加载完毕的操作
    async loadComplete() {
      this.loading = false;
      // 获取表单内部的项目id
      const { urlFiles, $refs: { businessForm: { formData, setFormData }}} = this;
      const id = this.$refs.businessForm.getPrjId();
      this.approveInfo.setPrjId(formData[id]);
      // 处理文件信息
      const form = urlFiles.map(({ fileId, fileVersion: version }) => ({ fileId, version }));
      if (form?.length) {
        const { data } = await getFileInfoByFileIdAndVersion(form);
        setFormData({ ...formData, fileInfoList: data.map(({ ...f }, index) => ({ ...f, fileType: urlFiles[index]?.fileType })) });
      }
      await this.$nextTick();// 为了触发vform塞入数据的监听事件
      if (this.flowType === 4 || this.flowType === 5) {
        const json = this.approveInfo.getFormData();
        this.$refs.businessForm.setFormData(json);
      }
    },
    // 切换项目
    async changeProject(prjId) {
      this.comKey++;
      if (this.isLowCode) return;
      this.showSteps = false;
      // 适配兼容之前数据
      const params = {
        ...this.flowInfo,
        name: this.flowInfo.flowName,
        prjId
      };
      this.$store.dispatch("setRouterParams", params);
    },
    // 查询处理人设置
    async queryApproveNodes() {
      const validate = await this.startValidate();
      if (validate) {
        await this.getBasicData();
        await this.getNodesEditor();
        this.showSteps = !this.showSteps;
      }
    },
    // 更新流程处理人
    async updateNodesEditor(val) {
      console.log("更新流程处理人", val);
      if (!val && this.showSteps) { // 流程处理人未展开状态
        this.getNodesEditor();
      } else if (val) {
        if (Array.isArray(val)) {
          const array = [];
          for (const iterator of val) {
            const { userIds = [] } = iterator;
            if (!userIds.length) {
              array.push({ ...iterator, usersList: [] });
            } else {
              const usersList = await this.getUserList(userIds);
              array.push({ ...iterator, usersList });
            }
          }
          this.approveInfo.setFormProcessor(array);
        } else {
          let params = {};
          const { nodeIndex = "", nodeKey = "", nodeName = "", userIds = [] } = val;
          if (!nodeIndex && !nodeKey && !nodeName) return;
          if (!userIds.length) {
            params = {
              ...val,
              usersList: []
            };
          } else {
            const usersList = await this.getUserList(userIds);
            params = {
              ...val,
              usersList
            };
          }
          this.approveInfo.setFormProcessor(params);
        }
      }
    },
    // 查询流程处理人
    async getNodesEditor() {
      const { flowDefinitionId, flowKey, formType, enterpriseId } = this.flowInfo;
      const param = await this.approveInfo.getFormData();
      const params = {
        flowDefinitionId, flowKey, enterpriseId, // flowDefinitionVersionId: "",
        prjId: Number(formType) === 1 ? this.prjId : "",
        param
      };
      // 查询新增的流程节点
      const res = await flowService.queryFlowNodeList(params);
      this.approveInfo.setFlowNodeDtoList(res.data || []);
    },
    // 获取userIds人员的所有信息
    async getUserList(userIds) {
      const { data } = await personInfoService.batchQueryCommonUserInfo(userIds);
      return data.map(e => {
        return {
          ...e,
          userName: e?.name + "(" + e.userName + ")",
          nodeId: e.userId,
          nodeName: e.username
        };
      });
    },
    // 校验表单是否把必填项输入
    async startValidate() {
      // 低代码表单校验
      if (this.isLowCode) {
        let boolean = false;
        try {
          boolean = await this.$refs.businessForm.startValidate();
        } catch (error) {
          this.$message.warning(error || "请填写完整表单");
        }
        return boolean;
      } else {
        return await this.$refs.businessForm.validateFormData();
      }
    },
    // 获取数据信息
    async getFormData() {
      const res = await flowService.getBusinessForm(this.flowInstanceId);
      this.detailMessage = res.data || {};
      const formData = res.data.object || {};
      this.$refs.businessForm.setFormData(formData);
    },
    // 获取基本信息数据
    async getBasicData(needValidation = true) {
      if (this.isLowCode) {
        const param = await this.$refs.businessForm.getFormData(needValidation);
        this.approveInfo.setFormData(param);
      } else {
        if (!needValidation) {
          const param = this.$refs.businessForm.getFormData();
          this.approveInfo.setFormData(param, "custom");
          return;
        }
        const promise = new Promise((resolve, reject) => {
          const boolean = this.$refs.businessForm.validateFormData();
          if (boolean) {
            const param = this.$refs.businessForm.getFormData();
            this.approveInfo.setFormData(param, "custom");
            resolve();
          } else {
            reject("表单校验失败");
          }
        });
        return promise;
      }
    },
    // 通用组件关联文件夹
    tableshow(val) {
      this.approveInfo?.addStartAttachedFiles(val);
    }
  }
};
// 审批、查看流程
export const flowDetailMixins = {
  data() {
    return {
      loading: false,
      flowMessage: {},
      detailMessage: "",
      basicForm: "",
      showSteps: false,
      approvalPrjId: "",
      showType: "", // user:处理人 ,img:流程图
      comKey: 0,
      nodes: []
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      enterpriseId: (state) => state.enterprise.enterpriseId
    }),
    approveInfo() {
      return getApprove(this.uuid);
    },
    // 流程类型 新增:1; 审批:2; 查看:3; 暂存:4; 重新发起:5;
    flowType() {
      return getApprove(this.uuid).flowType;
    },
    flowInfo() {
      return this.approveInfo?.getMessage();
    },
    // 是否低代码 true ：是
    isLowCode() {
      return this.flowInfo.customerForm === 2;
    },
    formId() {
      return this.flowInfo.formApprovePcCode || this.flowInfo.formCode;
    },
    flowImage() {
      return getFlowImage(this.flowInfo.flowImage.slice(7));
    },
    fileList() {
      return this.flowInfo?.attachedFiles?.map(e => {
        return {
          ...e,
          fileId: e.fileId,
          fileName: e.fileName
        };
      }) || [];
    },
    nodeList() {
      return getApprove(this.uuid)?.getFlowNodeDtoList();
    },
    prjId() {
      return this.approveInfo.getPrjId();
    },
    flowInstanceId() {
      return this.flowInfo?.flowInstanceId || "";
    },
    flowDefinitionId() {
      return this.flowInfo?.flowDefinitionId || "";
    },
    formFieldPermissionList() {
      return this.approveInfo?.formFieldPermissionList || [];
    }
  },
  methods: {
    async addInit(isH5) {
      this.loading = true;
      this.comKey++;
      // 审批查看优先加载流程梳理人，为表单使用
      await this.updateNodesEditor();
      if (this.isLowCode) {
        this.basicForm = customVform;
      } else {
        const params = {
          ...this.flowInfo,
          name: this.flowInfo.flowName,
          prjId: this.approvalPrjId
        };
        this.$store.dispatch("setRouterParams", params);
        this.basicForm = getFormComponent(this.flowInfo.flowKey, isH5);
      }
    },
    async onFlowFormLoad() {
      if (this.isLowCode) {
        return;
      }
      const json = this.approveInfo.getFormData();
        this.$refs.businessForm?.setFormData?.(json);
        this.$refs.businessForm?.disableForm?.();
        console.log(this.$refs.businessForm, "this.$refs.businessForm");
        // 兼容开发页面
        if (!this.$refs.businessForm?.disableForm) {
          this.$refs.businessForm.flowStatus = true;
        }
        this.loading = false;
    },
    // 低代码表单加载完毕
    async loadComplete() {
      this.loading = false;
      const { setFormData, setFormPremission } = this.$refs.businessForm;
      const json = this.approveInfo.getFormData();
      setFormData(json);
      for (const iterator of this.formFieldPermissionList) {
        if (iterator.type === "custom-sub-form") {
          if (this.formFieldPermissionList.some(e => e.parentContainer === iterator.formField && e.isCanUpdate === 1) && this.flowType !== 3) {
            iterator.isCanUpdate = 1;
          } else {
            iterator.isCanUpdate = 0;
          }
        }
      }
      setFormPremission(this.formFieldPermissionList);
      const formData = await this.$refs.businessForm.getFormData();
      // 可能没用到——设置项目id
      const id = this.$refs.businessForm.getPrjId();
      this.approveInfo.setPrjId(formData[id] || "");
      if (this.flowType === 3) this.$refs.businessForm.disableForm?.();
      bind_VF_Flow.call(this);
    },
    // 审批节点
    async updateNodesEditor() {
      const res = await flowService.queryFlowNodeAllList(this.flowInstanceId);
      this.approveInfo.setFlowNodeDtoList(res.data || []);
    },
    // 获取基本信息数据
    getBasicData(boolean = true) {
      return this.$refs.businessForm.getFormData(boolean);
    },
    queryFlowImage() {
      this.showType = "img";
    },
    closeDialog() {
      this.$emit("closeDialog");
    }
  }
};
